export const ROUTES = {
  home: '',
  login: 'auth/login',

  leasingScoring: 'autocredit-requests',
  leasingScoringCreate: 'autocredit-requests/create',
  leasingScoringRequest: (id = ':id') => `autocredit-requests/${id}`,

  leasedProperty: 'collateral-property',
  leasedPropertyCreate: 'collateral-property/create',
  leasedPropertyInfo: (id = ':id') => `collateral-property/${id}`,

  contracts: 'contracts',
  contractsCreate: 'contracts/create',
  contract: (id = ':id') => `contracts/${id}`,

  clients: 'clients',
  client: (id = ':id') => `clients/${id}`,

  clientAppeals: 'client-contract-appeals',
  clientAppeal: (id = ':id') => `client-contract-appeals/${id}`,

  assessments: 'assessments',
  vehicleAssessment: (appealId = ':appealId') => `assessments/${appealId}`,

  reports: 'reports'
};

/**
 * Коды модулей кабинета и корневые пути их разделов. Бэкенд присылает модули
 * сотрудника по коду; модуль, которого нет в этом списке, в кабинете не показывается.
 */
export const MODULE_ROUTES = {
  'autocredit-requests': ROUTES.leasingScoring,
  contracts: ROUTES.contracts,
  'collateral-property': ROUTES.leasedProperty,
  clients: ROUTES.clients,
  'client-contract-appeals': ROUTES.clientAppeals,
  assessments: ROUTES.assessments,
  reports: ROUTES.reports
};

export type TModuleCode = keyof typeof MODULE_ROUTES;

/**
 * Разделы, для которых есть API: их открывает сессия, пока бэкенд не присылает
 * модули сотрудника (docs/layout.md, «Скрыто до согласования»).
 */
export const AVAILABLE_MODULES: TModuleCode[] = ['autocredit-requests'];
